import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';
import containerQueryProps from '../../props/containerQueryProps';
import { RESY_WEB_DEPRECATE_EMAIL_PASSWORD_LOGIN } from '../../constants/optimizelyExperiments';
import useExperiment from '../Experiments/useExperiment';

import './Auth.scss';
import TargetedDelivery from '../Experiments/TargetedDelivery';

const HelpView = ({
  onSigninClick,
  onSignupClick,
  containerQuery,
  isEmailVerifying,
}) => {
  const { sm } = containerQuery;
  const [isDeprecateEmailPasswordLoginEnabled] = useExperiment(RESY_WEB_DEPRECATE_EMAIL_PASSWORD_LOGIN);
  const showEmailPasswordLogin = !isDeprecateEmailPasswordLoginEnabled;

  const signUpCopy = () => {
    if (isEmailVerifying) {
      return getTranslation({ translationKey: 'onboarding.create_account_with_phone', fallback: 'Create account with phone number instead' });
    }
    return getTranslation({ translationKey: 'onboarding.create_account', fallback: 'Create account with email instead' });
  };

  return (
    <div className={cx('AuthView', {
      'AuthView--sm': sm,
    })}
    >
      <TranslationProvider
        translationKey="onboarding.help_title"
      >
        <div className="AuthView__Text--bold">
          How can we help?
        </div>
      </TranslationProvider>
      <div className={cx('AuthView__Footer HelpView__Links', {
        'AuthView__Footer--sm': sm,
      })}
      >
        {showEmailPasswordLogin && (
          <TranslationProvider
            translationKey="onboarding.sign_in"
          >
            <button
              onClick={onSigninClick}
              type="button"
            >
              Log in with email & password
            </button>
          </TranslationProvider>
        )}
        <TargetedDelivery flagKey="login_optimization">
          <button onClick={onSignupClick} type="button" data-testid="sign-up-button">
            {signUpCopy()}
          </button>
        </TargetedDelivery>
      </div>
    </div>
  );
};

HelpView.propTypes = {
  onSigninClick: PropTypes.func.isRequired,
  onSignupClick: PropTypes.func.isRequired,
  containerQuery: containerQueryProps,
  isEmailVerifying: PropTypes.bool,
};

HelpView.defaultProps = {
  containerQuery: {},
  isEmailVerifying: false,
};

HelpView.displayName = 'HelpView';

export default HelpView;
